import React from 'react';
import { UserManagerInfo, UserManagers } from 'services/requests';
import { cellNumberTransform } from 'utils';
import Input from 'components/Input';
import { AlertTypes, BaseAlert } from 'components/Alerts';

import styles from './UserManager.module.css';
import messages from './UserManager.messages';

type Props = {
  userManagers?: UserManagers;
  defaultUserManager?: UserManagerInfo;
  showAlert?: boolean;
};

const inputProps = {
  type: 'text',
  className: styles.input,
  labelClassname: styles.inputLabel,
  disabled: true,
};

const UserManager: React.FC<Props> = ({
  userManagers,
  defaultUserManager,
  showAlert = false,
}) => {
  const availableManagers =
    userManagers?.filter(
      (userManager): userManager is NonNullable<UserManagerInfo> => userManager !== null,
    ) ?? (defaultUserManager ? [defaultUserManager] : []);

  if (!availableManagers.length) return null;

  const title =
    availableManagers.length > 1 ? messages.titlePlural : messages.titleSingular;

  return (
    <>
      <p className={styles.title}>{title}</p>

      {showAlert && (
        <div className={styles.alertContainer}>
          <BaseAlert type={AlertTypes.warning}>{messages.alertText}</BaseAlert>
        </div>
      )}

      <div className={styles.sectionContainer}>
        {availableManagers.map(({ email, userName, phoneNumber }) => (
          <div key={email}>
            <Input placeholder={messages.email} value={email} {...inputProps} />
            <Input placeholder={messages.userName} value={userName} {...inputProps} />
            <Input
              placeholder={messages.number}
              value={phoneNumber ? cellNumberTransform(phoneNumber) : ''}
              {...inputProps}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default UserManager;
